import { useCallback } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { CheckoutPriceCheck } from "@hsbc/portal";
import { FLIGHTS_PATH } from "@hsbc/utilities";

export const FlightsCheckoutPriceCheck = () => {
  const navigate = useNavigate();
  const onSearchAgain = useCallback(() => {
    navigate(FLIGHTS_PATH);
  }, [navigate]);
  return <CheckoutPriceCheck onSearchAgain={onSearchAgain} />;
};
